<template>
  <fts-tabs class="fts-form-script">
    <div class="script-header" slot="title" slot-scope="{title}">
      <div class="script-header__indicator" v-if="scriptTabIndicator(title)"></div>
      <div class="script-header__label">{{title}}</div>
    </div>
    <fts-tab title="Backend Script">
      <fts-script-editor
        editor-id="backendScript"
        v-model="formData.backendScript"
        lang="python"
        label="Backend Script"
      />
      <fts-script-editor
        editor-id="payloadScript"
        v-model="formData.payload"
        lang="python"
        label="Payload"
      />
    </fts-tab>
    <fts-tab title="Before Done Script">
      <fts-script-editor
        editor-id="beforeDoneScript"
        v-model="formData.beforeDoneScript"
        lang="javascript"
      />
    </fts-tab>
    <fts-tab title="After Done Script">
      <fts-script-editor
        editor-id="afterDoneScript"
        v-model="formData.afterDoneScript"
        lang="javascript"
      />
    </fts-tab>
  </fts-tabs>
</template>

<script>
import FTSTabs from "../elements/tabs/FTSTabs";
import FTSTab from "../elements/tabs/FTSTab";
import FTSScriptEditor from "./FTSScriptEditor";

export default {
  components: {
    "fts-tabs": FTSTabs,
    "fts-tab": FTSTab,
    "fts-script-editor": FTSScriptEditor,
  },
  props: {
    formData: Object,
  },
  methods: {
    scriptTabIndicator(item) {
      if (item === 'Backend Script')
        return Boolean(this.formData.backendScript);
      else if (item === 'Before Done Script')
        return Boolean(this.formData.beforeDoneScript);
      else if (item === 'After Done Script')
        return Boolean(this.formData.afterDoneScript);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-form-script {
  .script-header {
    display: flex;
    align-items: center;
    white-space: nowrap;
    .script-header__indicator {
      height: .375rem;
      width: .375rem;
      margin-right: .575rem;
      border-radius: 10em;
      background-color: var(--fts-success);
    }
  }
}
</style>